
import React from "react";
import "./subTitle.scss";

const SubTitle = ({ title, children, style }) => {
  return (
    <div className="flex flexBetween subTitle" style={style}>
      <div className="flex alignItemCenter">
        <div className="subTitle_icon"></div>
        <div className="subTitle_text">{title}</div>
      </div>
      <div>
        {children}
      </div>
    </div>
  );
};

export default SubTitle;